import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createService,
  deleteServiceById,
  fetchServices,
  updateService,
} from "../../redux/slices";
import Toast from "../../Hooks/useToast";

const useServiceController = () => {
  const dispatch = useDispatch();
  const { list, loading, saving, deleting } = useSelector(
    (state) => state.service
  );

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  const refetchServices = useCallback(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  const handleCreateService = async (payload) => {
    try {
      await dispatch(createService(payload)).unwrap();
      Toast("Service added successfully", "success");
      dispatch(fetchServices());
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to add service";
      Toast(msg, "error");
      throw err;
    }
  };

  const handleUpdateService = async (id, payload) => {
    try {
      await dispatch(updateService({ id, ...payload })).unwrap();
      Toast("Service updated successfully", "success");
      dispatch(fetchServices());
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to update service";
      Toast(msg, "error");
      throw err;
    }
  };

  const handleDeleteService = async (id) => {
    try {
      await dispatch(deleteServiceById(id)).unwrap();
      Toast("Service deleted successfully", "success");
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to delete service";
      Toast(msg, "error");
      throw err;
    }
  };

  return {
    values: {
      list,
      loading,
      saving,
      deleting,
    },
    functions: {
      handleCreateService,
      handleUpdateService,
      handleDeleteService,
      refetchServices,
    },
  };
};

export default useServiceController;
